import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { briefing_path } from '@routes';
import { ClickTarget, ContentType, click } from '@tracking';

import { Briefing, MIN_COMMENTS_COUNT } from '../../interfaces/homepage';
import TimeAgo from '../TimeAgo';
import CommentsCount from './CommentsCount';

interface BriefingProps {
  briefing: Briefing;
}

const BriefingFeedItem = ({
  briefing: { authors = [], dek, headline, id, publishedAt, slug, commentsCount },
}: BriefingProps) => {
  const { trackEvent } = useEventTracking({
    contentId: id,
    contentType: ContentType.Briefing,
    creatorIds: authors.map((author) => author.id),
  });

  return (
    <div className="border-0 border-b border-solid border-grayscale-gray px-16 py-32 sm:px-0 sm:py-48">
      <a
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.FeedBriefing }))}
        href={briefing_path(slug)}
        className="text-pretty"
      >
        <h3 className="briefing-headline m-0 p-0 font-suisse-screen text-headline-xxs font-normal text-primary-black transition-colors duration-200 hover:text-primary-magenta sm:mb-0 dark:hover:text-primary-pink">
          {headline}
        </h3>
        <div className="my-8 line-clamp-2 font-suisse-neue text-body-md text-primary-black *:m-0 *:hidden first-of-type:*:block sm:my-0">
          {dek}
        </div>
      </a>
      <div className="flex items-center ">
        <TimeAgo
          className={clsx('text-grayscale-gray', {
            'mr-10': commentsCount >= MIN_COMMENTS_COUNT,
          })}
          date={publishedAt}
        />
        {commentsCount >= MIN_COMMENTS_COUNT && (
          <CommentsCount numberOfComment={commentsCount} url={briefing_path(slug)} />
        )}
      </div>
    </div>
  );
};

export default BriefingFeedItem;
